export default __webpack_public_path__ + "static/media/arrow-expand.1224bd05.svg";